import { render } from "./LoginCard.vue?vue&type=template&id=225e8ab0&scoped=true"
import script from "./LoginCard.vue?vue&type=script&lang=js"
export * from "./LoginCard.vue?vue&type=script&lang=js"

import "./LoginCard.vue?vue&type=style&index=0&id=225e8ab0&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/外网-学校主页/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-225e8ab0"]])

export default __exports__